import Url from '@music/mobile-url';
import {makeActionCreator, makeActionType, getActionType, TYPES} from '../util/redux';
import Request from '../util/fetch';
import {Toast} from '../component/message';
export const PAGESIZE = 15;
export const RecordType = 'records';

makeActionType(RecordType, ['savepage']);

export const recordSuccess = makeActionCreator(getActionType(RecordType, 'success'));
export const recordFail = makeActionCreator(getActionType(RecordType, 'fail'));
export const recordSavePage = makeActionCreator(getActionType(RecordType, 'savepage'));

export const recordRequest = (data) => (dispatch) => {
    let page = data.page;
    dispatch({
        type: getActionType(RecordType, 'request'),
        payload: data
    })
    return Request.fetch({
        url: 'api/cloudvideo/promotion/record/list',
        data: {
            "limit": PAGESIZE,
            "offset": (page - 1) * PAGESIZE
        }
    }).then(res => {
        let resData = res.data;
        resData.page = page;
        dispatch(recordSuccess(resData));

    }).catch(err => {
        let rerr = Request.resolveError(err);
        dispatch(recordFail(rerr));
    })
}

 


// WEBPACK FOOTER //
// ./client/action/record.js